import { createSelector } from 'reselect'
import { RootState } from '../store'


const getWaterTestParams = (state: RootState)=> state.waterTestParams.data
const isLoading = (state: RootState)=> state.waterTestParams.loading
const error = (state: RootState)=> state.waterTestParams.error

const makeWaterTestParamsValues = createSelector(
  [getWaterTestParams],
  (params)=>{
    const items = params.map(param => {
      const {values, colors} = param
      const concat_value= values.reduce((acc, curr, idx)=> {
        acc.push( {
          value: curr,
          color: colors[idx] || colors[param.colors.length - 1],
        })
        return acc
      }, [] as {value: number, color: string}[])
      return {
        ...param,
        values: concat_value,
        unit: param.measurement
      }
    })
    return items
  }
)



export const WaterTestParamsSelectors = {
  getWaterTestParams,
  isLoading,
  error,
  makeWaterTestParamsValues,

}